export default "__VITE_ASSET__vJZb_3Ky__"